__turbopack_context__.v({
  "icon": "J0Iu5q_icon",
  "indicator": "J0Iu5q_indicator",
  "item": "J0Iu5q_item",
  "list": "J0Iu5q_list",
  "popup": "J0Iu5q_popup",
  "positioner": "J0Iu5q_positioner",
  "scrollArrow": "J0Iu5q_scrollArrow",
  "trigger": "J0Iu5q_trigger",
  "value": "J0Iu5q_value",
});
